// Frontend-only value sets for the tov surface. See enums/shell.ts for the rationale.

export const TOV_SECTION_KEYS = [
  "voice",
  "strategy",
  "channels",
  "sources",
  "activity",
] as const;
export const TOV_SECTION_KEY = {
  VOICE: "voice",
  STRATEGY: "strategy",
  CHANNELS: "channels",
  SOURCES: "sources",
  ACTIVITY: "activity",
} as const satisfies Record<string, TovSectionKey>;
export type TovSectionKey = (typeof TOV_SECTION_KEYS)[number];

export const TOV_FIELD_KINDS = ["text", "number", "select"] as const;
export type TovFieldKind = (typeof TOV_FIELD_KINDS)[number];
export const TOV_FIELD_KIND = {
  TEXT: "text",
  NUMBER: "number",
  SELECT: "select",
} as const satisfies Record<string, TovFieldKind>;

export const TOV_GUIDANCE_PROVENANCES = [
  "faro_baseline",
  "client",
  "mixed",
  "unknown",
] as const;
export type TovGuidanceProvenance = (typeof TOV_GUIDANCE_PROVENANCES)[number];
export const TOV_GUIDANCE_PROVENANCE = {
  FARO_BASELINE: "faro_baseline",
  CLIENT: "client",
  MIXED: "mixed",
  UNKNOWN: "unknown",
} as const satisfies Record<string, TovGuidanceProvenance>;

export const TOV_GUIDELINE_STATES = ["valid", "review", "unknown"] as const;
export type TovGuidelineState = (typeof TOV_GUIDELINE_STATES)[number];
export const TOV_GUIDELINE_STATE = {
  VALID: "valid",
  REVIEW: "review",
  UNKNOWN: "unknown",
} as const satisfies Record<string, TovGuidelineState>;

export const TOV_SOURCE_LABELS = [
  "Source evidence",
  "Source review required",
  "Source not established",
] as const;
export type TovSourceLabel = (typeof TOV_SOURCE_LABELS)[number];
export const TOV_SOURCE_LABEL = {
  SOURCE_EVIDENCE: "Source evidence",
  SOURCE_REVIEW_REQUIRED: "Source review required",
  SOURCE_NOT_ESTABLISHED: "Source not established",
} as const satisfies Record<string, TovSourceLabel>;

export const TOV_GUIDELINE_CATEGORYS = [
  "Voice & Tone",
  "Strategy",
  "Channels",
  "Sources",
] as const;
export type TovGuidelineCategory = (typeof TOV_GUIDELINE_CATEGORYS)[number];
export const TOV_GUIDELINE_CATEGORY = {
  VOICE_TONE: "Voice & Tone",
  STRATEGY: "Strategy",
  CHANNELS: "Channels",
  SOURCES: "Sources",
} as const satisfies Record<string, TovGuidelineCategory>;

export const TOV_SOURCE_STATES = ["linked", "not_established", "none"] as const;
export type TovSourceState = (typeof TOV_SOURCE_STATES)[number];
export const TOV_SOURCE_STATE = {
  LINKED: "linked",
  NOT_ESTABLISHED: "not_established",
  NONE: "none",
} as const satisfies Record<string, TovSourceState>;

export const TOV_MAPPING_STATES = [
  "unknown",
  "none",
  "running",
  "failed-resumable",
  "failed-restart",
  "succeeded",
  "superseded",
  "incompatible",
] as const;
export type TovMappingState = (typeof TOV_MAPPING_STATES)[number];
export const TOV_MAPPING_STATE = {
  UNKNOWN: "unknown",
  NONE: "none",
  RUNNING: "running",
  FAILED_RESUMABLE: "failed-resumable",
  FAILED_RESTART: "failed-restart",
  SUCCEEDED: "succeeded",
  SUPERSEDED: "superseded",
  INCOMPATIBLE: "incompatible",
} as const satisfies Record<string, TovMappingState>;
